import { FC, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { StorageKey } from '@shared/enum';
import { localStorageService } from '@shared/localStorageService';
import { useAppDispatch, useAppSelector } from '@state/configureStore';
import { selectIsAuthenticated, selectLanguage, setIsAuthenticated } from '@state/pageSlice';
import { useValidateTokenMutation } from '@state/userApi';

export const ProtectedRoute: FC = () => {
    const dispatch = useAppDispatch();
    const language = useAppSelector(selectLanguage);
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const [isReady, setIsReady] = useState(false);

    const [
        validateToken,
        {
            data: validateTokenData,
            error: errorValidateToken,
            isError: isErrorValidateToken,
            // isLoading: isLoadingValidateToken
        },
    ] = useValidateTokenMutation();

    // useEffect(() => {
    //   if (isLoadingValidateToken) {
    //     dispatch(enableLoading(LoaderType.validateToken));
    //   } else {
    //     dispatch(disableLoading(LoaderType.validateToken));
    //   }
    // }, [isLoadingValidateToken, isErrorValidateToken, dispatch]);

    useEffect(() => {
        setIsReady(false);
        validateToken({ language: language });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateToken]);

    useEffect(() => {
        if (validateTokenData && validateTokenData.data) {
            if (validateTokenData.data.isValid) {
                localStorageService.setItem(StorageKey.isAuthenticated, '1');
                dispatch(setIsAuthenticated(true));
            } else {
                localStorageService.clear();
                dispatch(setIsAuthenticated(false));
            }
            setIsReady(true);
        }
    }, [validateTokenData, dispatch]);

    useEffect(() => {
        if (errorValidateToken && isErrorValidateToken) {
            localStorageService.clear();
            dispatch(setIsAuthenticated(false));
            setIsReady(true);
        }
    }, [isErrorValidateToken, errorValidateToken, dispatch]);

    if (isAuthenticated === false && isReady) {
        return <Navigate to="/login" replace={true} />;
    } else if (!isReady) {
        return <></>;
    }

    return <Outlet />;
};
